import React, { useEffect, useState } from "react";
import { Box, Button, Stack, Typography } from "@mui/material";
import { ApplicantDetails } from "../../interface/application";
import ApplicantsTableList from "./ApplicantsTableList";

import FilterAltIcon from "@mui/icons-material/FilterAlt";
import FilterAltOffIcon from "@mui/icons-material/FilterAltOff";
import { useLocation } from "react-router-dom";
import { useAuth } from "../../hooks/useAuth";
import { useNotificationService } from "../notification";
import { getUrlPathId } from "../../utils/url-id";
import { useMutation } from "@tanstack/react-query";
import { apiGetApplicantionToJob } from "../../api/application";
import { JobIdProps } from "../../interface/job_board";
import { Pagination } from "../Pagination";
import {
  PaginationDetails,
  PaginationDetailsDummyData,
} from "../../interface/api_request";
import { FilterApplicantInputs } from "../FilterInputs";

const AllApplications = () => {
  const location = useLocation();
  const { showNotification } = useNotificationService();
  const [filters, setFilters] = useState("");
  const [compare, setCompare] = useState(false);
  const [applications_list, setApplication_list] = useState<ApplicantDetails[]>(
    [],
  );

  // set up pagination state
  const [pagination_state, setPagination_state] = useState<PaginationDetails>(
    PaginationDetailsDummyData,
  );

  useEffect(() => {
    const jobId = getUrlPathId(location?.pathname);
    mutation.mutate({ jobId: jobId });
  }, [pagination_state?.page, filters]);

  // call the function to get applicant list after job details has been fetched
  const mutation = useMutation({
    mutationFn: (field: JobIdProps) =>
      apiGetApplicantionToJob(field, `${pagination_state?.page}`, filters),
    onSuccess: (data) => {
      // Handle error
      if (data?.status === "error") {
        if ("msg" in data) {
          showNotification(data?.msg ?? "", "error");
          return;
        }
      }
      //  Handle success
      if ("data" in data) {
        if (!!data?.data?.meta) {
          setPagination_state({
            hasNextPage: data?.data?.meta?.hasNextPage,
            hasPrevPage: data?.data?.meta?.hasPrevPage,
            nextPage: data?.data?.meta?.nextPage,
            page: data?.data?.meta?.page,
            pages: data?.data?.meta?.pages,
            prevPage: data?.data?.meta?.prevPage,
            reads: data?.data?.meta?.reads,
            totalDocs: data?.data?.meta?.totalDocs,
            unReads: data?.data?.meta?.unReads,
          });
        }
        setApplication_list(data?.data?.data);
      }
    },
    onError: (error) => {
      // Handle error
      showNotification("Process failed", "error");
    },
  });

  return (
    <Box sx={{ padding: 2 }}>
      <>
        <Stack
          sx={{ my: 2 }}
          direction={"row"}
          justifyContent={"space-between"}
          alignItems={"center"}
        >
          <Typography variant="body1" color={"neutral"}>
            All Applicants
          </Typography>
          <Button onClick={() => setCompare(!compare)}>
            {compare ? <FilterAltOffIcon /> : <FilterAltIcon />}
          </Button>
        </Stack>
        {compare && (
          <FilterApplicantInputs
            loading={mutation.isPending}
            setFilterData={setFilters}
          />
        )}
        <ApplicantsTableList
          data={applications_list}
          loading={mutation.isPending}
        />
      </>

      <Pagination
        paginationState={pagination_state}
        setPaginationState={setPagination_state}
      />
    </Box>
  );
};

export default AllApplications;
